import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-public-patient-remote-monitoring',
  templateUrl: './public-patient-remote-monitoring.component.html',
  styleUrls: ['./public-patient-remote-monitoring.component.scss']
})
export class PublicPatientRemoteMonitoringComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }
}
